/**
 * Minimal browser shim for Node's `util` module.
 * Provides the subset needed by PDFKit, browserify-zlib, and stream-browserify.
 */

/** Equivalent to the `inherits` npm package — inlined to avoid an undeclared dependency. */
function inherits(
  // eslint-disable-next-line @typescript-eslint/naming-convention -- matches Node's `inherits` API
  ctor: { prototype: object; super_?: { prototype: object } },
  superCtor: { prototype: object },
): void {
  ctor.super_ = superCtor;
  ctor.prototype = Object.create(superCtor.prototype, {
    constructor: { value: ctor, enumerable: false, writable: true, configurable: true },
  });
}

function deprecate<T extends (...args: unknown[]) => unknown>(fn: T, _msg: string): T {
  return fn;
}

function inspect(obj: unknown): string {
  return JSON.stringify(obj);
}

export { inherits, deprecate, inspect };
export default { inherits, deprecate, inspect };
